import { render, staticRenderFns } from "./add-communication-modal.vue?vue&type=template&id=fa6239d2"
import script from "./add-communication-modal.vue?vue&type=script&lang=js"
export * from "./add-communication-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports